import { useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import type { SupportEmailRequestDetailDto } from '../types/support-email-request.types';
import { SupportEmailAiAnalysisStatus } from '../types/support-email-request.types';

export const useSupportEmailRequestDetailApi = (id?: string) => {
    const axiosInstance = useAxiosAuth();

    const { data, isLoading, error } = useQuery<SupportEmailRequestDetailDto>({
        queryKey: [ApiConfig.queries.superAdmin.supportEmailRequests.queryKeys.detail, id],
        enabled: Boolean(id) && id !== 'new',
        queryFn: async () => {
            const url = `${ApiConfig.queries.superAdmin.supportEmailRequests.endpoints.get}/${id}`;
            const response = await axiosInstance.get<SupportEmailRequestDetailDto>(url);
            return response.data;
        },
        refetchInterval: (query) =>
            query.state.data?.aiAnalysisStatus === SupportEmailAiAnalysisStatus.Pending
                ? 3000
                : false,
    });

    return { request: data, isLoading, error };
};
